import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { removeLoadingKey } from '../../helpers/common';

export const CashFlowLoadingKeys = {
    getCashFlowData: "GET_CASH_FLOW_DATA",
}

const initialState = {
    cashFlowData: null,
    loadingKeys: [],
    loading: false,
    error: null,
}

export const getCashFlowData = createAsyncThunk(
  'cashFlow/getCashFlowData',
  async ({
    startDate,
    endDate,
    valuesType,
  }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/cash-flow/data`, {
        params: {
          startDate,
          endDate,
          valuesType,
        }
      });
      return data;
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue(error.response.data)
      } else {
        return rejectWithValue(error.response.data.errors || error.response.data.error)
      }
    }
  }
)

export const cashFlowSlice = createSlice({
  name: 'cashFlow',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        .addCase(getCashFlowData.pending, (state) => {
            state.loading = true
            state.loadingKeys = [...state.loadingKeys, CashFlowLoadingKeys.getCashFlowData]
        })
        .addCase(getCashFlowData.fulfilled, (state, action) => {
            state.loading = false
            state.cashFlowData = action.payload;
            state.error = null;
            state.loadingKeys = removeLoadingKey(CashFlowLoadingKeys.getCashFlowData, state.loadingKeys)
        })
        .addCase(getCashFlowData.rejected, (state, action) => {
            state.loading = false
            state.cashFlowData = null;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(CashFlowLoadingKeys.getCashFlowData, state.loadingKeys)
        })
  }
})

export const {} = cashFlowSlice.actions;

export default cashFlowSlice.reducer;
